import LocalizedStrings from 'react-localization';

export const strings = new LocalizedStrings({
  en: {
    email: 'Email',
    enter_email: "Enter email",
    create: 'Create User',
    save: 'Save',
    update: 'Update',
    edit_profile: 'Edit Profile',
    password: 'Password',
    update_profile: 'Update Profile',
    change_password: 'Change Password',
    current_password: 'Current Password',
    new_password: 'New Password',
    confirm_password: 'Confirm Password',
    update_password: 'Update Password',
    password_not_match: 'New password and password confirmation do not match',
    password_success: 'Password changed successfully',
    profile_updated: 'profile updated successfully',
    phone: 'Phone',
    userName: 'Username',
    status: 'Status',
    org_name: 'Organization Name',
    org_code: 'Organization Code',
    user_code: 'User Code',
    action: 'Action',
    accept: 'Accept',
    reject: 'Reject',
    accepted: 'Accepted',
    rejected: 'Rejected',
    pending: 'pending',
    proceed: 'Proceed',
    edit: 'Edit',
    delete: 'Delete',
    successfully_created: 'Record saved successfully',
    are_you_sure: 'Are you sure?',
    confirm_reject: 'You want to reject this request!',
    delete_customer: 'You want to delete this customer!',
    delete_item: 'You want to delete this item!',
    success_item_deleted: 'The item has been deleted.',
    yes_button: 'Yes, Reject it!',
    yes_delete: 'Yes, delete it!',
    yes_cancel: 'Cancel',
    rejected: 'Rejected!',
    deleted: 'Eliminated !',
    success_deleted: 'The customer has been deleted ',
    success_rejected: 'The request has been rejected.',
    inquire_request: 'Inquire Request',
    search_placeholder: 'Search Name / Email / Phone / Organization Name.',
    search_placeholder_customers:
      'Search Name / Email / Phone / Organization Name / Organization Code / User Code .',
    search_placeholder_items: 'Search Item Code / Item Description',
    item_code: 'Item Code',
    item_description: 'Item Description',
    item_stock: 'Stock',
    item_barcode: 'Barcode Number',
    item_price: 'Total price with VAT included',
    manage_item: 'Manage Item',
    create_item: 'Create Item',
    edit_item: 'Edit Item',
    save_success: 'Record save successfully.',
    go_back: 'Go Back',
    fill_fields: 'Fill in all fields!',

    description_valid_error: 'Enter a valid description not include any special characters or symbols',
    users: 'Users',
    discount_pr: 'Discount in percent',
    discount_dollar: 'Discount in dollar',
    value: 'Value',
    total: 'Total',
    cash: 'Cash',
    card: 'Card',
    credit: 'Cheque',
    transferencia: 'Transfer',
    credito: 'Credit',
    comment: 'Comment',
    rut_number: 'RUT Number',
    name: 'Name',
    addr_1: 'Address Line 1',
    addr_2: 'Address Line 2',
    state: 'State',
    country: 'Country',
    b_details: 'Business Details',
    edit: 'Edit',
    print: 'Print',
    new: 'New',
    search: 'Search here',
    item_remove: 'Item deleted successfully',
    back: 'Back',
    item_desc: 'Description',
    next: 'Next',
    add_item: 'Add',
    bills: 'Bills',
    invoice: 'Invoice',
    credit_note: 'Credit Note',
    delivery_note: 'Delivery Note',
    quote: 'Quote',
    debit_note: 'Debit Note',
    transport_required: 'Add transport data is required',
    required_fields: 'Fill in all the required fields',
    add_excel_file: 'Upload multiple items',
    upload: 'Upload',
    preview: 'Preview',
    valid_items: 'Valid items',
    invalid_items: 'Invalid items',
    accepted_file_format: 'Accepted file format (.csv, .xlsx, .xls)',
    expiration_date: 'Expiration date',
    expiration_day: 'Expiration day',
    expiration_month: 'Expiration month',
    expiration_year: 'Expiration year',
    email_valid_error: "Please enter a valid email",
    invalid_rut: 'Invalid RUT number',
    restaurant: "Restaurant",
    restaurant_tables: "Restaurant Tables",
    table_name: "Table name",
    tables: "Tables",
    delete_table: "You want to delete this table!",
    create_table: "Create Table",
    edit_table: "Edit Table",
    select_user_role: "Select user role",
    select_table_status: 'Select table status',
    select_all: "Select all",
    choose_table: 'Choose Table',
    no_data_available: 'No Data Available',
    add_food: 'Add Food',
    order_summary: 'Order Summary',
    no_food_added: "No Food Added",
    add_more_food: "Add More Food",
    place_order: "Place Order",
    mark_as_paid: "Mark As Paid",
    generic_note: "Generic Note",
    delete_item: "Delete item?",
    delete_item_msg: "Are you sure you want to delete item?",
    select_food_quantity: "Select Food Quantity",
    enter_food_instruction: "Enter Food Instruction",
    grand_total: "Grand total",
    order_placed_successfully: "Order Placed Successfully",
    continue: "Continue",
    mark_as_paid_msg: "Are you sure you want to mark this order as paid?",
    yes_mark_as_paid: "Yes,Marked as Paid",
    mark_as_paid_success_msg: "The order has been successfully marked as paid.",
    mark_as_paid_success_title: "Successfully marked order as paid",
    select_food: "Select Food",
    add_cart: "Add cart",
    search_by_food_name: "Search by food name",
    please_select_food: "Please select a food",
    restaurant_order: "Restaurant Order",
    dashboard: "Dashboard",
    restaurant_kitchens: "Restaurant Kitchens",
    kitchen_name: "Kitchen name",
    chefs: "Chefs",
    create_kitchen: "Create Kitchen",
    delete_kitchen: "You want to delete this kitchen!",
    select_chefs: "Select chefs",
    edit_kitchen: "Edit Kitchen",
    restaurant_bars: "Restaurant Bars",
    bar_name: "Bar name",
    waiters: "Waiters",
    create_bar: "Create Bar",
    delete_bar: "You want to delete this Bar!",
    select_waiters: "Select waiters",
    edit_bar: "Edit Bar",
    restaurant_spaces: "Restaurant Spaces",
    create_space: "Create Space",
    edit_space: "Edit Space",
    delete_space: "You want to delete this Space!",
    space_name: "Space name",
    space_description: "Space description",
    select_tables: "Select tables",
    success_kitchen_deleted: "The kitchen has been deleted",
    success_bar_deleted: "The bar has been deleted",
    select_kitchens: "Select kitchens",
    select_bars: "Select bars",
    success_space_deleted: "The space has been deleted",
    select_space: "Select space",
    item_type: "Item type",
    preparation_area: "Preparation Area",
    item_out_of_stock_err: "You have reached the stock limit for this item. More items cannot be added because there is no more stock.",
    mark_as_paid_warning: "You can't mark as paid order because you have some of food items which order is not placed, either delete that food items or place order for that items.",
    convert_to_bill: "Convert To Bill",
    convert_to_invoice: "Convert To Invoice",
    current_orders: "Current Orders",
    past_orders: "Past Orders",
    orders: "Orders",
    food_quantity: "Food quantity",
    note: "Note",
    food_name: "Food name",
    complete: "Complete",
    accept_item: "Are you sure you want to accept this item?",
    complete_item: "Are you sure you want to mark the item as complete?",
    accept_item_title: "Accept item?",
    complete_item_title: "Complete item?",
    yes: "Yes",
    no: "No",
    item_accept_msg: "Item successfully accepted",
    item_complete_msg: "Item successfully completed",
    accepted: "Accepted",
    completed: "Completed",
    restaurant_report: "Restaurant Report",
    search_by_order_no: "Search by order number",
    order_number: "Order Number",
    date: "Date",
    order_amount: "Order Amount",
    view: "View",
    receipt: "Receipt",
    order: "Order",
    select_kitchen_or_bar: "Select kitch or bar",
    item_upload_confirmation_msg: "All items will be uploaded in",
    yes_upload: "Yes upload",
    all: "All",
    with_bill: "With bill",
    with_invoice: "With invoice",
    without_bill_invoice: "Without bill & invoice",
    minutes_ago: "minutes ago",
    minute_ago: "minute ago",
    seconds_ago: "seconds ago",
    second_ago: "second ago",
    hours_ago: "hours ago",
    hour_ago: "hour ago",
    day_ago: "day ago",
    days_ago: "days ago",
    weeks_ago: "weeks ago",
    week_ago: "week ago",
    months_ago: "months ago",
    month_ago: "month ago",
    years_ago: "years ago",
    year_ago: "year ago",
    bulk_upload_documents: "Bulk upload documents",
    download_demo_file: "Download Demo File",
    has_subitem: "Has subItem",
    subitems: "Subitems",
    add_subitem: "Add subitem",
    create_subitem: "Create subitem",
    edit_subitem: "Edit subitem",
    fill_subitems_fields: 'Fill in all subitems fields!',
    update_item_stock: "Update items back in stock",
    email_require_err_msg: "Email is required",
    current_order: "Current Order",
    place_new_order: "Place New Order",
    add_note: "Add Note",
    edit_note: "Edit Note",
    items: "items",
    view_cart: "View Cart",
    qty: "Qty",
    item: "Item",
    price: "Price",
    make_payment: "Make Payment",
    subtotal: "Subtotal",
    confirm: "Confirm",
    select_your_food: "Select Your Food",
    login_description_msg: "Delicious meals, just a tap away",
    login_footer_msg: "Hungry? We've got you covered!",
    welcome_to: "Welcome to",
    view_note: "View Note",
    view_all: "View All",
    order_detail: "Order Detail",
    no_current_orders: "No Current Orders",
    no_past_orders: "No Past Orders",
    loading:"Loading",
    preparing: "Preparing",
    ready_for_pickup: "Ready For Pickup",
    delivered: "Delivered",
    unknown: "Unknown",
    payment_successful: "Payment Successful!",
    thank_you_for_order: "Thank you for your order.",
    your_food_is_being_prepared: "Your food is being prepared.",
    your_order_id: "Your Order ID",
    search_for_food: "Search for food",
    menu: "Menu",
    my_profile: "My Profile",
    contact_us: "Contact Us",
    faqs: "FAQs",
    mobile_number: "Mobile Number",
    send_message: "Send Message",
    write_your_msg: "Write your message",
    contact_us_success_msg: "Your message has been received. Our team will review it and respond promptly.",
    contact_us_success_title_msg: "Thanks for Reaching Out!",
    login_title: 'Login',
    login_desc: "Enter your email to sign in.",
    add_tip: "Add Tip",
    tip: "Tip",
    go_to_home: "Go To Home",
    page_not_found_msg: "Page you are looking was not found!",
    page_not_found_title: "Not found",
    no_food_item_seach_found_msg: "No food items or categories found for your search.",
    empty_food_data_msg: "No food data available. Please try again later.",
    something_went_wrong_while_scan: "Something went wrong while scanning",
    please_scan_again_msg: "Please try scanning the code again or contact the Restaurant Admin.",
    loading_step1_title: "Loading restaurant information",
    loading_step2_title: "Loading restaurant configuration",
    loading_step1_subtitle: "Step 1: Fetching restaurant details",
    loading_step2_subtitle: "Step 2: Loading restaurant settings",
    something_went_wrong: "Something went wrong!",
    something_went_wrong_while_initiate_payment: "Something went wrong while initiating your payment. Please contact restaurant admin.",
    retry_payment: "Retry Payment",
    payment_failed_title: "Payment Failed",
    payment_failed_message: "We're sorry, but your payment could not be processed. Please try again or contact us if the problem persists.",
    processing_payment: "Processing Payment",
    please_wait_while_we_confirm_your_order: "Please wait while we confirm your order",
    payment_summary: "Payment Summary",
    payment_time: "Payment Time",
    go_to_orders: "Go To Orders",
    amount: "Amount",
    payment_reference_id: "Payment Reference ID",
    payment_method: "Payment Method",
    order_complete_title: "Order Complete!",
    order_complete_subtitle: "Your order is ready for pickup",
    completion_time: "Ready at",
    order_items: "Order Items",
    more_items: "more items",
    view_order: "View Order"
  },
  es: {
    add_item: 'Agregar',
    next: 'Continuar',
    item_desc: 'Descripción',
    back: 'Regresar',
    item_remove: 'Item eliminado exitosamente',
    print: 'Imprimir',
    new: 'Nuevo',
    edit: 'Editar',
    addr_1: 'Dirección',
    addr_2: 'Comuna',
    state: 'Región',
    country: 'País',
    b_details: 'Giro',
    comment: 'Comentario',
    rut_number: 'RUT (Debe ingresar números o k)',
    name: 'Nombre o Razón Social',
    email: ' Correo electrónico',
    enter_email: "Enter email es",
    create: 'Crear usuario',
    save: 'Guardar',
    update: 'Actualizar',
    edit_profile: 'Edit Profile',
    password: ' Clave',
    update_profile: 'Update Profile',
    change_password: 'Change Password',
    current_password: 'Current Password',
    new_password: 'New Password',
    confirm_password: 'Confirm Password',
    update_password: 'Update Password',
    password_not_match: 'La nueva contraseña y la confirmación de la contraseña no coinciden',
    password_success: 'Password changed successfully',
    profile_updated: 'profile updated successfully',
    phone: 'Teléfono',
    userName: 'Rut de usuario',
    status: 'Estado',
    org_name: 'Organization Name',
    org_code: 'Organization Code',
    user_code: 'User Code',
    action: 'Action',
    accept: 'Accept',
    reject: 'Reject',
    delete: 'Borrar',
    successfully_created: 'Registro guardado con éxito',
    accepted: 'Aceptado',
    rejected: 'Reclamado',
    pending: 'Pendiente',
    search: 'Busca aquí',
    proceed: 'Continuar',
    are_you_sure: '¿Está seguro?',
    confirm_reject: 'You want to reject this request!',
    delete_customer: 'Quiere eliminar este cliente',
    delete_item: 'Quiere eliminar este Item',
    success_item_deleted: 'The item has been deleted.',
    yes_button: 'Yes, Reject it!',
    yes_delete: 'Sí, eliminar',
    yes_cancel: 'Cancelar',
    rejected: 'Rejected!',
    deleted: '¡Eliminado!',
    // deleted: 'Eliminated !',
    success_deleted: 'El registro ha sido eliminado ',
    success_rejected: 'The request has been rejected.',
    inquire_request: 'Inquire Request',
    search_placeholder: 'Search Name / Email / Phone / Organization Name.',
    search_placeholder_customers:
      'Search Name / Email / Phone / Organization Name / Organization Code / User Code .',
    search_placeholder_items: 'Search Item Code / Item Description',
    item_code: 'SKU',
    item_description: 'Nombre',
    item_stock: 'Stock',
    item_price: 'Precio total con IVA incluido',
    item_barcode: 'Código de barra',
    manage_item: 'Crear Item',
    create_item: 'Create Item',
    edit_item: 'Editar Item',
    save_success: 'Record save successfully.',
    go_back: 'Regresar',
    fill_fields: 'Fill in all fields!',
    description_valid_error: 'Enter a valid description not include any special characters or symbols',
    users: 'Users',
    discount_pr: 'Descuento %',
    discount_dollar: 'Descuento $',
    value: 'Vuelto',
    total: 'Total',
    cash: 'Efectivo',
    card: 'Tarjeta',
    credit: 'Cheque',
    transferencia: 'Transferencia',
    credito: 'Credito',
    bills: 'Boleta',
    invoice: 'Factura',
    credit_note: 'Nota de crédito',
    delivery_note: 'Guía de despacho',
    quote: 'Cotizacion',
    debit_note: 'Nota de débito',
    transport_required: 'Agregar datos del transporte se requiere',
    required_fields: 'Llena todos los campos requeridos',
    add_excel_file: 'Subir varios elementos',
    upload: 'Subir',
    preview: 'Avance',
    valid_items: 'Artículos válidos',
    invalid_items: 'Artículos no válidos',
    accepted_file_format: 'Formato de archivo aceptado (.csv, .xlsx, .xls)',
    expiration_date: 'Fecha de expiración',
    expiration_day: "Dia de expiracion",
    expiration_month: "Mes de expiracion",
    expiration_year: 'ano de caducidad',
    email_valid_error: "Por favor, introduce una dirección de correo electrónico válida",
    invalid_rut: 'Invalid RUT number',
    restaurant: "Restaurante",
    restaurant_tables: "Mesas de Restaurante",
    table_name: "Nombre de la mesa",
    tables: "Mesas",
    delete_table: "Quiere eliminar este mesa",
    create_table: "Crear mesa",
    edit_table: "Editar mesa",
    select_user_role: "Seleccione rol de usuario",
    select_table_status: 'Seleccionar estado de la tabla',
    select_all: "Seleccionar todo",
    choose_table: 'Elegir Mesa',
    no_data_available: 'Datos no disponibles',
    add_food: 'Agregar comida',
    order_summary: 'Resumen del pedido',
    no_food_added: 'No se agrega comida',
    add_more_food: "Agregar más comida",
    place_order: "Realizar pedido",
    mark_as_paid: "Marcar como pagado",
    generic_note: "Nota genérica",
    delete_item: "¿Eliminar elemento?",
    delete_item_msg: "¿Está seguro de que desea eliminar el elemento?",
    select_food_quantity: "Seleccione la cantidad de comida",
    enter_food_instruction: "Ingrese la instrucción de alimentos",
    grand_total: "gran total",
    order_placed_successfully: "Pedido realizado con éxito",
    continue: "Continuar",
    mark_as_paid_msg: "¿Está seguro de que desea marcar este pedido como pagado?",
    yes_mark_as_paid: "Sí, marcado como pagado",
    mark_as_paid_success_msg: "El pedido se ha marcado correctamente como pagado.",
    mark_as_paid_success_title: "Pedido marcado correctamente como pagado",
    select_food: "Seleccionar comida",
    add_cart: "Añadir carrito",
    search_by_food_name: "Buscar por nombre de alimento",
    please_select_food: "Por favor seleccione una comida",
    restaurant_order: "Orden de restaurante",
    dashboard: "Panel",
    restaurant_kitchens: "Cocinas de restaurante",
    kitchen_name: "Nombre de la cocina",
    chefs: "cocineros",
    create_kitchen: "crear cocina",
    delete_kitchen: "¡Quieres eliminar esta cocina!",
    select_chefs: "Seleccionar chefs",
    edit_kitchen: "Editar cocina",
    restaurant_bars: "Restaurante Bares",
    bar_name: "Nombre de la barra",
    waiters: "camareros",
    create_bar: "Crear barra",
    delete_bar: "¡Quieres eliminar esta barra!",
    select_waiters: "Seleccionar camareros",
    edit_bar: "Barra de edición",
    restaurant_spaces: "Espacios de restaurante",
    create_space: "Crear espacio",
    edit_space: "Editar espacio",
    delete_space: "¡Quieres eliminar este Espacio!",
    space_name: "Nombre del espacio",
    space_description: "Descripción del espacio",
    select_tables: "Seleccionar mesas",
    success_kitchen_deleted: "La cocina ha sido eliminada",
    success_bar_deleted: "La barra ha sido eliminada",
    select_kitchens: "Seleccionar cocinas",
    select_bars: "Seleccionar barras",
    success_space_deleted: "El espacio ha sido eliminado",
    select_space: "Seleccionar espacio",
    item_type: "Tipo de artículo",
    preparation_area: "Área de preparación",
    item_out_of_stock_err: "Has alcanzado el límite de stock para este artículo. No se pueden añadir más artículos porque no hay más stock.",
    mark_as_paid_warning: "You can't mark as paid order because you have some of food items which order is not placed, either delete that food items or place order for that items.",
    convert_to_bill: "Convertir a boleta",
    convert_to_invoice: "Convertir a factura",
    current_orders: "Órdenes actuales",
    past_orders: "Pedidos anteriores",
    orders: "Pedidos",
    quantity: "Cantidad",
    food_quantity: "Cantidad de comida",
    note: "Nota",
    food_name: "Nombre del alimento",
    complete: "Completo",
    accept_item: "¿Estás seguro de que deseas aceptar este artículo?",
    complete_item: "¿Está seguro de que desea marcar el elemento como completo?",
    accept_item_title: "¿Aceptar artículo?",
    complete_item_title: "¿Artículo completo?",
    yes: "Sí",
    no: "No",
    item_accept_msg: "Artículo aceptado exitosamente",
    item_complete_msg: "Artículo completado con éxito",
    accepted: "Aceptado",
    completed: "Completado",
    restaurant_report: "Informe del restaurante",
    search_by_order_no: "Buscar por número de pedido",
    order_number: "Número de pedido",
    date: "Fecha",
    order_amount: "Monto del pedido",
    view: "Vista",
    receipt: "Recibo",
    order: "Orden",
    select_kitchen_or_bar: "Seleccione cocina o barra",
    item_upload_confirmation_msg: "Todos los artículos se cargarán en",
    yes_upload: "Sí, subir",
    all: 'Todos',
    with_bill: "Con boleta",
    with_invoice: "Con factura",
    without_bill_invoice: "Sin boleta & factura",
    minutes_ago: "Hace minutos",
    minute_ago: "Hace un minuto",
    seconds_ago: "Hace segundos",
    second_ago: "Hace un segundo",
    hours_ago: "Hace horas",
    hour_ago: "Hace una hora",
    day_ago: "Hace días",
    days_ago: "Hace días",
    weeks_ago: "Hace semanas",
    week_ago: "Hace una semana",
    months_ago: "Hace meses",
    month_ago: "Hace un mes",
    years_ago: "Hace años",
    year_ago: "Hace un año",
    bulk_upload_documents: "Carga masiva de documentos",
    download_demo_file: "Descargar archivo de demostración",
    has_subitem: "Tiene un subtema",
    subitems: "Subtemas",
    add_subitem: "Añadir subelemento",
    create_subitem: "Crear subelemento",
    edit_subitem: "Editar subelemento",
    fill_subitems_fields: "Complete todos los campos de los subelementos",
    update_item_stock: "Actualizar artículos nuevamente disponibles en stock",
    email_require_err_msg: "Se requiere correo electrónico",
    current_order: "Órdene actuale",
    place_new_order: "Realizar un nuevo pedido",
    add_note: "Agregar nota",
    edit_note: "Editar nota",
    items: "elementos",
    view_cart: "Ver carrito",
    qty: "cantidad",
    item: "Artículo",
    price: "Precio",
    make_payment: "Realizar pago",
    subtotal: "Total parcial",
    confirm: "Confirmar",
    select_your_food: "Seleccione su comida",
    login_description_msg: "Comidas deliciosas, a un toque de distancia.",
    login_footer_msg: "¿Tienes hambre? ¡Te tenemos cubierto!",
    welcome_to: "Bienvenido a",
    view_note: "Ver nota",
    view_all: "Ver todo",
    order_detail: "Detalle del pedido",
    no_current_orders: "No hay pedidos actuales",
    no_past_orders: "No hay pedidos anteriores",
    loading:"Cargando",
    preparing: "Preparando",
    ready_for_pickup: "Listo para recoger",
    delivered: "Entregado",
    unknown: "Desconocido",
    payment_successful: "Pago exitoso!",
    thank_you_for_order: "Gracias por su pedido.",
    your_food_is_being_prepared: "Su comida se está preparando.",
    your_order_id: "ID de su pedido",
    search_for_food: "Buscar comida",
    menu: "Carta",
    my_profile: "Mi Perfil",
    contact_us: "Contáctanos",
    faqs: "FAQs",
    mobile_number: "Número de teléfono móvil",
    send_message: "Enviar mensaje",
    write_your_msg: "Escribe tu mensaje",
    contact_us_success_msg: "Hemos recibido su mensaje. Nuestro equipo lo revisará y le responderá a la brevedad.",
    contact_us_success_title_msg: "¡Gracias por contactarnos!",
    login_title: 'Acceso',
    login_desc: "Introduce tu correo electrónico para iniciar sesión.",
    add_tip: "Añadir propina",
    tip: "Propina",
    go_to_home: "Ir a inicio",
    page_not_found_msg: "¡La página que estás buscando no fue encontrada!",
    page_not_found_title: "Extraviado",
    no_food_item_seach_found_msg: "No se encontraron artículos ni categorías de alimentos para su búsqueda.",
    empty_food_data_msg: "No hay datos disponibles sobre los alimentos. Inténtelo de nuevo más tarde.",
    something_went_wrong_while_scan: "Algo salió mal durante el escaneo",
    please_scan_again_msg: "Intente escanear el código nuevamente o comuníquese con el administrador del restaurante.",
    loading_step1_title: "Cargar la información del restaurante",
    loading_step2_title: "Cargar la configuración del restaurante",
    loading_step1_subtitle: "Paso 1: Obtener los datos del restaurante",
    loading_step2_subtitle: "Paso 2: Cargar la configuración del restaurante",
    something_went_wrong: "¡Algo salió mal!",
    something_went_wrong_while_initiate_payment: "Algo salió mal al iniciar tu pago. Contacta con el administrador del restaurante.",
    retry_payment: "Reintentar pago",
    payment_failed_title: "Pago Fallido",
    payment_failed_message: "Lo sentimos, pero su pago no pudo ser procesado. Por favor, inténtelo de nuevo o contáctenos si el problema persiste.",
    processing_payment: "Procesando pago",
    please_wait_while_we_confirm_your_order: "Por favor, espere mientras confirmamos su pedido",
    payment_summary: "Resumen del pago",
    payment_time: "Tiempo de pago",
    go_to_orders: "Ir a pedidos",
    amount: "Cantidad",
    payment_reference_id: "ID de Referencia de Pago",
    payment_method: "Método de pago",
    order_complete_title: "¡Pedido Completo!",
    order_complete_subtitle: "Su pedido está listo para recoger",
    completion_time: "Listo a las",
    order_items: "Artículos del Pedido",
    more_items: "más artículos",
    view_order: "Ver Pedido"
  }
});
